




export const InsuranceByIdPage = () => {
  return (<></>)
}